import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { login as apiLogin, fetchMe, setToken, clearToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);     // null = checking, false = logged out
  const [ready, setReady] = useState(false);

  const check = useCallback(async () => {
    if (!getToken()) { setUser(false); setReady(true); return; }
    try {
      const me = await fetchMe();
      setUser(me);
    } catch {
      clearToken();
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const signIn = async (email, password) => {
    const data = await apiLogin(email, password);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const signOut = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
